import { createRouter } from './app/router';

const appRoot = document.getElementById('app');
if (!appRoot) {
  throw new Error('Missing #app mount point');
}

createRouter(appRoot).start();
